import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IUploadDirectorDocumentsRequest, IUploadDirectorDocumentsResponse } from '../models/upload-documents.model';
import { fromUploadDocumentsActions } from '../actions';

export const uploadDocumentsFeatureKey = 'uploadDocuments';

export interface UploadDocumentsState {
  uploadDirectorDocuments: IUploadDirectorDocumentsRequest;
  uploadDirectorDocumentsResponse: IUploadDirectorDocumentsResponse;
  uploadDirectorDocumentsFailure: IGenericError<ErrorResponse>;
}

export const initialState: UploadDocumentsState = {
  uploadDirectorDocuments: undefined,
  uploadDirectorDocumentsResponse: undefined,
  uploadDirectorDocumentsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromUploadDocumentsActions.loadUploadDocuments, (state, action) => ({
    ...state,
    uploadDirectorDocuments: action.request
  })),
  on(fromUploadDocumentsActions.loadUploadDocumentsSuccess, (state, action) => ({
    ...state,
    uploadDirectorDocumentsResponse: action.response
  })),
  on(fromUploadDocumentsActions.loadUploadDocumentsFailure, (state, action) => ({
    ...state,
    uploadDirectorDocumentsFailure: action.error
  }))
);

export const getUploadedDocumentsRequest = (state: UploadDocumentsState) => state.uploadDirectorDocuments;
export const getUploadedDocumentsResponse = (state: UploadDocumentsState) => state.uploadDirectorDocumentsResponse;
export const getUploadedDocumentsFailure = (state: UploadDocumentsState) => state.uploadDirectorDocumentsFailure;
